import React, { useRef, useState } from "react";
import { Form, Modal, Spin } from "antd";
import { Upload } from "antd";
import toast from "react-hot-toast";
import svg111 from "../../../../assets/svg/svg111.svg";
import axiosInstance from "../../../../instance";

const { Dragger } = Upload;

const BatchBillingReconciliationAddModal = ({
  open,
  handleCancel,
  setData,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [fileName, setfileName] = useState("");
  const [fileLoading, setFileLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const props = {
    name: "file",
    multiple: false,
    accept: ".xlsx,.xls,.csv",
    showUploadList: true,

    beforeUpload: async (file) => {
      const isValid =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type === "text/csv" ||
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".xls") ||
        file.name.endsWith(".csv");

      if (!isValid) {
        toast.error("Please upload only Excel (.xlsx, .xls) or CSV files");
        return false;
      }

      const isGt10MB = file.size / 1024 / 1024 > 10;

      if (isGt10MB) {
        toast.error("File must be smaller than 10MB!");
        return false;
      }

      setUploadedFile(file);
      setfileName(file.name);
      toast.success(`${file.name} file selected successfully.`);

      return false;
    },

    onDrop(e) {
      setFileLoading(false);
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

    const onFinish = async (data) => {
    if (!uploadedFile) {
      toast.error("Please upload file");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", uploadedFile);

      const response = await axiosInstance.post('/api/v1/payments/reconcile-billing', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const result = response.data;

      if (result?.success) {
        toast.success(result?.messages?.message || "File uploaded successfully");
        setData(result?.data?.result);
        form.resetFields();
        setUploadedFile(null);
        setfileName("");
        handleCancel();
      } else {
        toast.error(result?.message || "Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error?.response?.data?.message || "An error occurred while uploading the file");
    } finally {
      setLoading(false);
    }
  };
 


   

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title="Upload Reconciliation Statement"
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
        footer={null}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="supportingDocument"
            label="Documents"
            rules={[
              {
                required: false,
                message: "Please upload a file",
              },
            ]}
          >
            <Dragger className="attachment" {...props}>
              <div className="flex flex-col justify-center">
                <div className="flex justify-center mb-5">
                  <img src={svg111} alt="svg111" />
                </div>
                <p className="ant-upload-text !ml-2">
                  <span className="text-posta-blue">Choose a file</span>
                  <span className="ml-2 text-[#667085]">or drag and drop</span>
                  <br></br>
                  <span className="!mt-[10rem] text-[#667085]">
                    Excel (.xlsx, .xls) or CSV files up to 10 MB
                  </span>
                </p>
              </div>
            </Dragger>
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={loading}
                >
                  {loading ? <Spin /> : "Upload"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default BatchBillingReconciliationAddModal;
